import baseAPI from "../../api/baseAPI"

const getCurrency = () => {
    return baseAPI.get("currency")
}

export default {
    getCurrency
}